import * as sonbp from "sonbp";
import * as ifbase from "../../base";
import { photoMani } from "../../tool";
import { drawCommon } from "../drawCommon"

/**
* ポスカ用クリップイメージのコンテンツエディター
* @summary クリップイされているメージに対して操作ハンドルを表示し、イメージ対する編集操作を行います。
* @description exClipImage に対する編集操作を行います。
*/
export class poscaClipImageEditor extends sonbp.listener.editor.clipImageEditor {

	private _ifdto: ifbase.ifDto;

	// -----------------------------------------------
	// Constructors（コンストラクタ）
	// -----------------------------------------------

	/**
	 * コンストラクタ
	 */
	public constructor(ifdto: ifbase.ifDto) {
		super();

		this._ifdto = ifdto;
	}

	// -----------------------------------------------
	// Methods（外部アクセス用メソッド）
	// -----------------------------------------------

	/**
	 * 処理取得
	 * @override
	 */
	public take(select: sonbp.type.select): boolean {

		//override moveEditor
		let that = this;
		let p = function () {
			if (select.items.length == 0) return false;

			let m = select.mode(sonbp.constant.editModeType.MOVE_NG);
			let r = select.mode(sonbp.constant.editModeType.RESIZE_NG);
			let d = select.mode(sonbp.constant.editModeType.ROTATION_NG);

			if (m && r && d) return false;

			that.init();
			return true;
		}();

		//override clipImageEditor
		let notake = (): boolean => {
			that._v._lm.unsetPickUpper(this);
			return false;
		}

		if (select.items.length != 1) return notake();
		if (select.items[0]._sonbpItemType != sonbp.constant.sonbpItemType.group) return notake();

		let group = select.items[0] as sonbp.object.groupItem;

		if (!group.isImageClipper) return notake();
		if (group.childs.length != 1) return notake();

		let child = group.childs[0];

		if (group.info.mode(sonbp.constant.editModeType.CONTENTS_EDIT_NG) && !p) return notake();
		if (child.type != sonbp.constant.itemType.XOBJECT) return notake();

		//FFポスカ判定
		if (child.info.vendor_property.ffpsc?.file_id == "@DUMMY@") return notake();

		// 同一アイテムで更新処理中の場合は、以下をすっとばす
		if (this._editData && this._editData.pref && this._editData.updating && this._editData.pref.item.id == group.id) {
			return true;
		}

		let preEData = this._editData;

		// 編集データ取得

		this._editData = new sonbp.listener.editor.editClipImageData();

		let pRefs = sonbp.util.obj.getItemRefById(this._v, [group.id]);
		this._editData.v = new sonbp.listener.editor.vitem(child);
		this._editData.pref = pRefs[0];

		let bw = sonbp.util.js.getBrowser();

		if (bw.name == "ie" || bw.name == "edge") {
			this._editData.clipCmds = sonbp.util.c2d.getFlatCommandsOfCommands(group.clip_item._commands, 10);
		} else {
			this._editData.clipCmds = group.clip_item._commands;
		}

		if (preEData?.smask != null && group.gstate.hasSoftMask && preEData.pref.item.id == group.id) {

			//同じ画像枠ならマスク画像使いまわし
			this._editData.smask = preEData.smask;

		} else {

			this._editData.smask = null;

			if (group.gstate.hasSoftMask) {
				// smaskがある場合は、smask用の画像を取得

				let maskData = this._v._cm.getImg(group.gstate.soft_mask.src, group._apply_pageIdx, group._apply_layerIdx, 0, false, false, true);

				if (maskData.status == 2 || maskData.img.complete) {

					this._editData.smask = maskData.img;
				} else {

					sonbp.util.js.loopSleep(this._ifdto.bpView._eff.triggerCnt, this._ifdto.bpView._eff.triggerInterval,
						function () {
							try {
								if (maskData.status == 2 || maskData.img.complete) {

									this._editData.smask = maskData.img;
									this._v._dm.editDraw();

									return false;
								}
								return true;
							} catch (e) {
								return false;
							}
						},
						"",
						function () {
							console.error("take loading loop out.");
						});

				}
			}
		}

		this._v._lm.setPickUpper(this, this._select.items[0]);

		this.init();

		return true;
	}

	// -----------------------
	// イベント受付機能 関数
	// -----------------------

	/**
	 * キーダウン処理
	 * @summary キー操作無効
	 * @override
	 */
	public evKeydown(e: KeyboardEvent): sonbp.type.listerResult {
		return new sonbp.type.listerResult();
	}

	/**
	 * ムーブ内部処理
	 * @override
	 */
	protected onMove(vp: sonbp.type.localViewPosition, hasShiftKey: boolean): sonbp.type.listerResult {
		if (this._state.hasMoversHandle) return super.onMove(vp, hasShiftKey);

		if (!this._state?.handle) return new sonbp.type.listerResult();

		// 編集中の処理

		let idx = this._v._dm.pageIdxs.indexOf(this._state.mvs.apply_pageIdx);
		let spt = this._state.spt.docPt[idx];
		let ept = vp.docPt[idx];
		let docPt = vp.docPt[this._v._dm.pageIdxs.indexOf(this._select.pageIndex)];

		if (this._state.type == 999) {

			// 先送りしたハンドルをセット

			let handle = this.getEditHandle(vp);

			if (handle) {
				this.editStateChange(true);
				this._state.start(handle, vp, this.getMovers());
			} else {
				this.init();
				this.editStateChange(false);
			}

			return new sonbp.type.listerResult();
		}

		if (this._state.prepare && this._state.type == 16 && this.actionModeForMTouch == 2) {
			// ２点タッチのリサイズ＆回転モードで、最初のアクションでどちらかの制御に決定するモードの場合
			// →ここでモードをきめてやる

			const skip = (): sonbp.type.listerResult => {
				let result = new sonbp.type.listerResult();
				result.isPrevent = true;
				result.isDrawEditCanvas = true;
				return result;
			}

			let spts = this._state.spt.touchLocalVps.length > 1 ? this._state.spt.touchLocalVps : this._state.spt.changedTouchLocalVps;
			let epts = vp.touchLocalVps.length > 1 ? vp.touchLocalVps : vp.changedTouchLocalVps;

			let rad0 = sonbp.util.c2d.deg(sonbp.util.c2d.getRadian(spts[0].docPt[idx], spts[1].docPt[idx]));
			let rad1 = sonbp.util.c2d.deg(sonbp.util.c2d.getRadian(epts[0].docPt[idx], epts[1].docPt[idx]));
			let r = Math.abs(rad1 - rad0);
			const sr = 3;

			let len0 = sonbp.util.c2d.getDistance(spts[0].docPt[idx], spts[1].docPt[idx]);
			let len1 = sonbp.util.c2d.getDistance(epts[0].docPt[idx], epts[1].docPt[idx]);
			let s = Math.abs(1 - len1 / len0);
			const ss = 0.03;

			// どちらかの閾値を先に超えた場合にモードを決定する

			if (sr > r && ss > s) return skip();

			if (sr < r && ss < s) {
				// 両方閾値を超えている場合は超えた割合が大きい方を採用
				if (s / ss > r / sr) this._state.handle.type = 14;
				else this._state.handle.type = 15;
			}
			else if (ss < s) {
				// スケールだけ閾値越え
				this._state.handle.type = 14;
			}
			else if (sr < r) {
				// 回転だけ閾値越え
				this._state.handle.type = 15;
			}
		}

		this._state.prepare = false;

		// 操作処理

		const wakuPita = this._editData.pref.item.info.vendor_property.ffpsc?.waku_pita ?? true;
		let pmatrix = sonbp.util.c2d.matrix2(this._editData.pref.item.matrix, this._editData.pref.item._apply_pmatrix);

		if (spt.equals(ept)) {
		}
		else if (this._state.type == 11) {
			let omatrix = sonbp.util.c2d.matrixInverse(pmatrix);
			omatrix[4] = omatrix[5] = 0;
			let v = sonbp.util.c2d.setPointMatrix(new sonbp.type.point(docPt.x - spt.x, docPt.y - spt.y), omatrix);

			this._editData.v.save();
			this._editData.v.init();
			this._editData.v.move(v.x, v.y);

			if (!this.allowBlank && this.checkBlank())
				this._editData.v.restore();
			else if (!wakuPita && photoMani.chkIfImageExceedWaku(this._editData.pref.item, this._editData.v))
				this._editData.v.restore();
			else {
				this._state.ept = vp;
				this._state.handle.data.nept = docPt;
			}
		}
		else if (this._state.type == 12) {
			let omatrix = sonbp.util.c2d.matrixInverse(pmatrix);
			omatrix[4] = omatrix[5] = 0;
			let v = sonbp.util.c2d.setPointMatrix(new sonbp.type.point(docPt.x - spt.x, docPt.y - spt.y), omatrix);

			this._editData.v.save();
			this._editData.v.init();
			var pts = this._editData.v.getPoints();
			var sc = this.scaleSub2(v, this._editData.v.apply_matrix, this._editData.v.apply_points, pts, this._state.ptIdx);

			this._editData.v.scale(sc[0], sc[1]);

			var oppsitIdx = 8 - this._state.ptIdx;
			var pts2 = this._editData.v.getPoints();
			this._editData.v.move(pts[oppsitIdx].x - pts2[oppsitIdx].x, pts[oppsitIdx].y - pts2[oppsitIdx].y);

			if (!this.allowBlank && this.checkBlank())
				this._editData.v.restore();
			else if (!wakuPita && photoMani.chkIfImageExceedWaku(this._editData.pref.item, this._editData.v))
				this._editData.v.restore();
			else {
				this._state.ept = vp;
				this._state.handle.data.nept = docPt;
			}
		}
		else if (this._state.type == 13) {
			var points = sonbp.util.c2d.setPointsMatrix(this._editData.v.getPoints(), pmatrix);
			let rad = this.rotateSub(spt, docPt, points, this._rotationScore);

			this._editData.v.save();
			this._editData.v.init();
			this._editData.v.rotate(rad);

			if (!this.allowBlank && this.checkBlank())
				this._editData.v.restore();
			else if (!wakuPita && photoMani.chkIfImageExceedWaku(this._editData.pref.item, this._editData.v))
				this._editData.v.restore();
			else {
				this._state.ept = vp;
				this._state.handle.data.nept = docPt;
			}
		}
		else if (this._state.type == 14 || this._state.type == 15 || this._state.type == 16) {

			// --------------------
			// ２点 リサイズ／回転／リサイズ＆回転
			// --------------------

			let spts = this._state.spt.touchLocalVps.length > 1 ? this._state.spt.touchLocalVps : this._state.spt.changedTouchLocalVps;
			let epts = vp.touchLocalVps.length > 1 ? vp.touchLocalVps : vp.changedTouchLocalVps;

			let spt0 = spts[0].docPt[idx];
			let spt1 = spts[1].docPt[idx];
			let ept0 = epts[0].docPt[idx];
			let ept1 = epts[1].docPt[idx];
			let doScale = this._state.type == 14 || this._state.type == 16;
			let doRotate = this._state.type == 15 || this._state.type == 16;

			// 拡大率

			const sd = sonbp.util.c2d.getDistance(spt0, spt1);
			const ed = sonbp.util.c2d.getDistance(ept0, ept1);
			let scale = ed / sd

			//ffposca
			//{
			//	//拡縮制限チェック
			//	let s = {
			//		sx: scale,
			//		sy: scale
			//	};
			//	photoMani.chkScaleOverWaku(this._ifdto, this, this._editData.v.apply_matrix, this._editData.v.apply_points, s);
			//	scale = s.sx;
			//}

			// 回転角度

			const srad = sonbp.util.c2d.getRadian(spt0, spt1);
			const erad = sonbp.util.c2d.getRadian(ept0, ept1);
			let rad = erad - srad;

			this._editData.v.save();
			this._editData.v.init();

			if (doScale) {
				const pt0 = this._editData.v.getPoints()[4];
				this._editData.v.scale(scale, scale);
				const pt1 = this._editData.v.getPoints()[4];
				this._editData.v.move(pt0.x - pt1.x, pt0.y - pt1.y);
			}
			if (doRotate) {
				this._editData.v.rotate(rad);
			}

			if (!this.allowBlank && this.checkBlank())
				this._editData.v.restore();
			else if (!wakuPita && photoMani.chkIfImageExceedWaku(this._editData.pref.item, this._editData.v))
				this._editData.v.restore();
			else {
				this._state.ept = vp;
				this._state.handle.data.nept = docPt;
			}
		}

		var result = new sonbp.type.listerResult();
		result.cursor = this.getEditCursor(this._state.handle);
		result.isPrevent = true;
		result.isDrawEditCanvas = true;
		result.isDrawPickCanvas = true;

		return result;
	}

	/**
	 * エンド内部処理
	 * @override
	 */
	protected onEnd(vp: sonbp.type.localViewPosition, hasShiftKey: boolean): sonbp.type.listerResult {
		if (this._state.hasMoversHandle) return super.onEnd(vp, hasShiftKey);

		if (!this._state.commitable) {
			let r = new sonbp.type.listerResult();
			r.isDrawFrontCanvas = true;
			return r;
		}

		let idx = this._v._dm.pageIdxs.indexOf(this._state.mvs.apply_pageIdx);
		let spt = this._state.spt.docPt[idx];
		let ept = this._state.ept.docPt[idx];
		let nept = this._state.handle.data.nept;
		let pmatrix = sonbp.util.c2d.matrix2(this._editData.pref.item.matrix, this._editData.pref.item._apply_pmatrix);

		this._editData.updating = true;

		// 変更処理
		let that = this;
		if (this._state.type == 11) {

			let omatrix = sonbp.util.c2d.matrixInverse(pmatrix);
			omatrix[4] = omatrix[5] = 0;
			let v = sonbp.util.c2d.setPointMatrix(new sonbp.type.point(nept.x - spt.x, nept.y - spt.y), omatrix);

			this._v._om.itemChange([this._editData.pref], function (itemRefs) {

				var image = (itemRefs[0].item as sonbp.object.groupItem).childs[0] as sonbp.object.xobjectItem;

				image.move(v.x, v.y);

				//はみ出しチェック
				photoMani.adjustPositionWaku(itemRefs[0].item, image);

				return true;
			});

		} else if (this._state.type == 12) {

			let omatrix = sonbp.util.c2d.matrixInverse(pmatrix);
			omatrix[4] = omatrix[5] = 0;
			let v = sonbp.util.c2d.setPointMatrix(new sonbp.type.point(nept.x - spt.x, nept.y - spt.y), omatrix);

			this._v._om.itemChange([this._editData.pref], function (itemRefs) {

				var image = (itemRefs[0].item as sonbp.object.groupItem).childs[0] as sonbp.object.xobjectItem;

				var pts = image.points;
				var sc = that.scaleSub2(v, image.matrix, image.getPlainPoints(), pts, that._state.ptIdx);

				image.scale(sc[0], sc[1]);

				var oppsitIdx = 8 - that._state.ptIdx;
				var pts2 = image.points;
				image.move(pts[oppsitIdx].x - pts2[oppsitIdx].x, pts[oppsitIdx].y - pts2[oppsitIdx].y);

				//はみ出しチェック
				photoMani.adjustPositionWaku(itemRefs[0].item, image);

				return true;
			});

		} else if (this._state.type == 13) {

			this._v._om.itemChange([this._editData.pref], function (itemRefs) {

				var image = (itemRefs[0].item as sonbp.object.groupItem).childs[0] as sonbp.object.xobjectItem;

				let points = sonbp.util.c2d.setPointsMatrix(image.points, pmatrix);

				var rad = that.rotateSub(spt, ept, points, that._rotationScore);

				image.rotate(sonbp.util.c2d.deg(rad));

				//はみ出しチェック
				photoMani.adjustPositionWaku(itemRefs[0].item, image);

				return true;
			});
		}
		else if (this._state.type == 14 || this._state.type == 15 || this._state.type == 16) {

			// --------------------
			// ２点 リサイズ／回転／リサイズ＆回転
			// --------------------

			let spts = this._state.spt.touchLocalVps.length > 1 ? this._state.spt.touchLocalVps : this._state.spt.changedTouchLocalVps;
			let epts = this._state.ept.touchLocalVps.length > 1 ? this._state.ept.touchLocalVps : this._state.ept.changedTouchLocalVps;

			let spt0 = spts[0].docPt[idx];
			let spt1 = spts[1].docPt[idx];
			let ept0 = epts[0].docPt[idx];
			let ept1 = epts[1].docPt[idx];
			let doScale = this._state.type == 14 || this._state.type == 16;
			let doRotate = this._state.type == 15 || this._state.type == 16;

			// 拡大率

			const sd = sonbp.util.c2d.getDistance(spt0, spt1);
			const ed = sonbp.util.c2d.getDistance(ept0, ept1);
			let scale = ed / sd

			// 回転角度

			const srad = sonbp.util.c2d.getRadian(spt0, spt1);
			const erad = sonbp.util.c2d.getRadian(ept0, ept1);
			let rad = erad - srad;

			this._v._om.itemChange([this._editData.pref], (itemRefs) => {

				const image = (itemRefs[0].item as sonbp.object.groupItem).childs[0] as sonbp.object.xobjectItem;

				if (doScale) {
					const pt0 = image.points[4];
					image.scale(scale, scale);
					const pt1 = image.points[4];
					image.move(pt0.x - pt1.x, pt0.y - pt1.y);
				}
				if (doRotate) {
					image.rotate(sonbp.util.c2d.deg(rad));
				}

				//はみ出しチェック
				photoMani.adjustPositionWaku(itemRefs[0].item, image);

				return true;
			});
		}

		this._editData.updating = false;

		this.init();
		this._editData.v.initByItem();
		this._parent.acceptEditComplete();
		this.noticeChange();

		var result = new sonbp.type.listerResult();
		result.cursor = this.getEditCursor(this._state.handle);
		result.isReDraw = true;
		result.isPrevent = true;

		return result;
	}

	/**
	 * マウスアウト処理
	 * @override
	 */
	public evMouseout(e: MouseEvent, vp: sonbp.type.localViewPosition): sonbp.type.listerResult {
		if (!this._select.isSamePageIndex) return new sonbp.type.listerResult();

		let noedit = this.moveNotInEdit(e, vp);
		if (noedit) return noedit;

		console.debug("★★ドラッグ中のマウスアウト！");
		this.init();
		if (this._editData?.v != null) {
			this._editData.v.initByItem();
			this._parent.acceptEditComplete();
		}

		let result = new sonbp.type.listerResult();
		result.isReDraw = true;
		result.isPrevent = true;

		return result;
	}

	// -----------------------
	// 描画機能 関数
	// -----------------------

	/**
	 * pickLayerCanvasへの描画
	 * @override
	 */
	public drawPickCanvas(co: sonbp.draw.canvasOperator): void {
		//console.debug("drawPickCanvas");
		this.gdrawEditCanvas(co);

		//ちらつき対処
		//選択画像切換えのタイミングでdm.doc.redraw発火により紙面クリアされるため、画像がちらつく。
		//ここで一時的にpickCanvasに描画することで、ちらつきしないようにごまかしている。
		co.ctx.save();
		{
			this._v._dm.pageTransform(this._select.pageIndex, co.ctx);
			this.drawImage(co);
		}
		co.ctx.restore();
	}

	/**
	 * eidtCanvasへの描画
	 * @override
	 */
	public drawEditCanvas(co: sonbp.draw.canvasOperator): void {

		//console.debug("drawEditCanvas", "state", this._state.type);

		if (this._editData == null) return;

		if (this._select.items[0].gstate.hasSoftMask && this._editData.smask == null) {
			//mask.onload前の描画を回避
			return;
		}


		let clipImage = this._select.items[0] as sonbp.object.groupItem;
		//let image = this._editData.v.item as sonbp.object.xobjectItem;
		
		var that = this;
		let clipMatrix = sonbp.util.c2d.matrix2(clipImage.matrix, clipImage._apply_pmatrix);
		let points = sonbp.util.c2d.setPointsMatrix(this._editData.v.getPoints(), clipMatrix);
		//let clipCmds = sonbp.util.c2d.setCommandsMatrix(clipImage.clip_item._commands, clipMatrix);

		co.initialize();
		this._v._dm.pageTransform(this._select.pageIndex, co.ctx);

		co.ctx.save();
		{
			/*
			 * sonbp2のclopImageEditorではクリップ画像はdrawPickCanvasで描画となっているが、
			 * frontCanvasよりも最前面に描画する必要あるため、drawEditCanvasでの描画としている。
			 */

			// クリッピングカバー
			co.ctx.save();
			{
				this.drawImage(co);
			}
			co.ctx.restore();

			// クリッピングマスク図形の描画
			co.ctx.save();
			{
				drawCommon.drawSelectedBox(this._ifdto, co.ctx, clipImage);
			}
			co.ctx.restore();

			// ハンドル描画
			co.ctx.save();
			{
				if (!ifbase.util.chkIsPhotoManiInSP(this._ifdto)) {

					//画像矩形描画
					co.ctx.strokeStyle = this._v._stl.selectLineStyle;
					co.ctx.lineWidth = 1.5 / this._v._dm.scaleRate
					co.ctx.setLineDash([]);
					co.ctx.fillStyle = this._v._stl.editHandleFillStyle;
					this.drawRect(co.ctx, points);
				}
				let resizeNg = this._isResizeNg ? this._isResizeNg : this._editData.v.item.info.mode(sonbp.constant.editModeType.RESIZE_NG);
				let aspectNg = this._isAspectNg ? this._isAspectNg : this._editData.v.item.info.mode(sonbp.constant.editModeType.ASPECT_NG);
				let rotateNg = this._isRotateNg ? this._isRotateNg : this._editData.v.item.info.mode(sonbp.constant.editModeType.ROTATION_NG);

				co.ctx.strokeStyle = this._v._stl.selectLineStyle;
				co.ctx.lineWidth = this._v._stl.selectLineBorderWidth / this._v._dm.scaleRate
				co.ctx.setLineDash(sonbp.util.c2d.csLineDash(this._v._stl.selectLineDash, this._v._dm.scaleRate));
				co.ctx.fillStyle = this._v._stl.editHandleFillStyle;
				this.drawRect(co.ctx, points);
				this.drawRotatePoint(co.ctx, points, points, points, rotateNg);
				this.drawResizePoint(co.ctx, points, points, points, resizeNg, aspectNg);
			}
			co.ctx.restore();
		}
		co.ctx.restore();
	}

	private drawImage(co: sonbp.draw.canvasOperator): void {

		let clipImage = this._select.items[0] as sonbp.object.groupItem;
		let image = this._editData.v.item as sonbp.object.xobjectItem;

		var that = this;
		let clipMatrix = sonbp.util.c2d.matrix2(clipImage.matrix, clipImage._apply_pmatrix);
		let points = sonbp.util.c2d.setPointsMatrix(this._editData.v.getPoints(), clipMatrix);
		let clipCmds = sonbp.util.c2d.setCommandsMatrix(clipImage.clip_item._commands, clipMatrix);

		co.ctx.save();
		{
			var width = 1, height = 1;
			if (image.subtype == sonbp.constant.itemSubType.FORM) width = image.size[0], height = image.size[1];

			var imgData = this._v._cm.getImg(image.src, clipImage._apply_pageIdx, clipImage._apply_layerIdx);

			var imgDraw = function () {
				co.ctx.save();
				co.ctx.transform(clipMatrix[0], clipMatrix[1], clipMatrix[2], clipMatrix[3], clipMatrix[4], clipMatrix[5]);
				co.ctx.transform(that._editData.v.apply_matrix[0], that._editData.v.apply_matrix[1], that._editData.v.apply_matrix[2], that._editData.v.apply_matrix[3], that._editData.v.apply_matrix[4], that._editData.v.apply_matrix[5]);
				co.ctx.save();
				co.ctx.transform(1, 0, 0, -1, 0, height);
				co.ctx.drawImage(imgData.img, 0, 0, imgData.img.width, imgData.img.height, 0, 0, width, height);
				co.ctx.restore();
				co.ctx.restore();
			}

			if (!ifbase.util.chkIsPhotoManiInSP(this._ifdto)) {
				// 画像描画（半透明部分の画像）
				imgDraw();

				// 薄くしている
				co.ctx.save();
				co.ctx.fillStyle = this._v._stl.clipCoverFillStyle;
				this.drawRect(co.ctx, points, true, false);
				co.ctx.restore();
			}

			// クリッピング（↓の画像をクリップ）
			sonbp.util.c2d.commandDraw(clipCmds, co.ctx);
			co.ctx.closePath();
			co.ctx.clip();

			// 画像描画（クリッピングマスク内の濃い画像）
			imgDraw();

			// smask
			if (this._editData.smask != null) {
				co.ctx.save();

				co.ctx.globalCompositeOperation = 'destination-out';
				var maskDataImg = this._editData.smask;

				let mb = clipImage.gstate.soft_mask_bounds;
				co.ctx.transform(1, 0, 0, 1, mb[0], mb[1]);

				let mm = clipImage.gstate.soft_mask_matrix;
				co.ctx.transform(mm[0], mm[1], mm[2], mm[3], mm[4], mm[5]);

				co.ctx.transform(1, 0, 0, -1, 0, mb[3] - mb[1]);
				co.ctx.drawImage(maskDataImg, 0, 0, maskDataImg.width, maskDataImg.height, 0, 0, mb[2] - mb[0], mb[3] - mb[1]);

				co.ctx.restore();
			}
		}
		co.ctx.restore();
	}

	/**
	 * eidtCanvasへの描画
	 */
	public gdrawEditCanvas(co: sonbp.draw.canvasOperator): void {

		//console.debug("gdrawEditCanvas");

		if (ifbase.util.chkIsPhotoManiInSP(this._ifdto)) {
			return;
		}

		// 選択候補描画
		ifbase.constants.LTYPES_CAN_RESELECT.forEach(layerType => {

			let layer = ifbase.util.getLayer(this._ifdto, layerType).layer;
			let items = layer.items.filter(d => d.id != this._select.items[0].id)
			co.ctx.save();
			{
				drawCommon.drawCandidate(this._ifdto, co.ctx, items);
			}
			co.ctx.restore();
		});
	}

	// -----------------------------------------------
	// Methods（内部関数）
	// -----------------------------------------------

	/**
	 * リサイズハンドルの描画
	 * @override
	 */
	protected drawResizePoint(ctx: CanvasRenderingContext2D, points: sonbp.type.point[], base_points: sonbp.type.point[], out_points: sonbp.type.point[], isResizeNg: boolean, isAspectNg: boolean): void {

		if (!this.hasResizePoint()) return;
		drawCommon.drawResizePoint(this._ifdto, ctx, points, base_points, out_points, isResizeNg, isAspectNg);
	}

	/**
	 * 回転ハンドルの描画
	 * @override
	 */
	protected drawRotatePoint(ctx: CanvasRenderingContext2D, points: sonbp.type.point[], base_points: sonbp.type.point[], out_points: sonbp.type.point[], isRotateNg: boolean): void {

		if (!this.hasRotatePoint()) return;
		drawCommon.drawRotatePoint(this._ifdto, ctx, points, base_points, out_points, isRotateNg);
	}

	protected getResizeHandle(docPt: sonbp.type.point, points: sonbp.type.point[], base_points: sonbp.type.point[], out_points: sonbp.type.point[], resizeNg: boolean, aspectNg: boolean): sonbp.listener.editor.handle {

		if (this._ifdto.client == ifbase.constants.CLIENT_SP) {
			//SPモードはアイコン操作させない
			return null;
		}

		let sz = this._v._stl.editHandleSize / this._v._dm.scaleRate;

		let isV = sonbp.util.c2d.isVHForPoints(true, points, 3);
		let isH = sonbp.util.c2d.isVHForPoints(false, points, 3);

		if (isV || isH) return null;

		if (!resizeNg) {

			let chks = [2];

			for (let i = 0; i < chks.length; i++) {
				let pt = ifbase.util.getIconPoint(this._ifdto, points, chks[i], sz);
				if (this.checkHandle(pt, sz * 3, docPt)) {
					return { type: 2, ptIdx: chks[i] };
				}
			}
		}

		return null
	}
	protected getRotateHandle(docPt: sonbp.type.point, points: sonbp.type.point[], base_points: sonbp.type.point[], out_points: sonbp.type.point[], rotateNg: boolean): sonbp.listener.editor.handle {

		if (this._ifdto.client == ifbase.constants.CLIENT_SP) {
			//SPモードはアイコン操作させない
			return null;
		}

		if (!rotateNg) {
			let sz = this._v._stl.editHandleSize / this._v._dm.scaleRate;

			let chks = [0];

			for (let i = 0; i < chks.length; i++) {
				let pt = ifbase.util.getIconPoint(this._ifdto, points, chks[i], sz);
				if (this.checkHandle(pt, sz * 3, docPt)) {
					return { type: 3, ptIdx: chks[i] };
				}
			}
		}

		return null
	}

	// -----------------------------------------------
	// Methods（内部アクセス用メソッド）
	// -----------------------------------------------

	/**
	 * 適用するスケールを演算する
	 * @override
	 */
	protected scaleSub2(v: sonbp.type.point, aMatrix: number[], aPoints: sonbp.type.point[], pts: sonbp.type.point[], ptIdx: number): number[] {

		// ベクトルを変換
		var rad = sonbp.util.c2d.getRadian(pts[4], pts[5]);
		var vv = sonbp.util.c2d.getPointWithRotate(new sonbp.type.point(0, 0), v, -rad);

		// ベクトル調整
		if (ptIdx % 3 == 0) vv.x *= -1;
		else if (ptIdx % 3 == 1) vv.x = 1;
		if (ptIdx <= 2) vv.y *= -1;
		else if (3 <= ptIdx && ptIdx <= 5) vv.y = 1;

		// スケールを算定
		var w = sonbp.util.c2d.getDistance(pts[3], pts[5]);
		var h = sonbp.util.c2d.getDistance(pts[1], pts[7]);
		var sx = (w + vv.x) / w;
		var sy = (h + vv.y) / h;

		//console.debug("v", v, "vv", vv, "rad", rad, "w", w, "h", h, "ww", w + vv.x, "hh", h + vv.y, "sx", sx, "sy", sy);

		// アスペクト比固定
		if (sx > sy) sx = sy;
		else sy = sx;

		// 逆転抑止
		if (sx < 0 || sy < 0) {
			sx = sy = 0.25;
		}

		//拡縮制限チェック
		let s = {
			sx: sx,
			sy: sy
		};

		//console.debug("s", s);

		let vi = this._editData.v;
		photoMani.chkScaleOverWaku(this._ifdto, this, aMatrix, aPoints, s);
		sx = s.sx;
		sy = s.sy;

		return [sx, sy];
	}
}

